/**
 * @module
 * @internal
 */
export var Name;
(function (Name) {
    Name["NordrheinWestfalen"] = "Nordrhein-Westfalen";
})(Name || (Name = {}));
export var WeatherCondition;
(function (WeatherCondition) {
    WeatherCondition["SONNIG"] = "sonnig";
    WeatherCondition["KLAR"] = "klar";
    WeatherCondition["HEITER"] = "heiter";
    WeatherCondition["WOLKIG"] = "wolkig";
    WeatherCondition["LEICHT_BEWOELKT"] = "leicht bew\u00F6lkt";
    WeatherCondition["STARK_BEWOELKT"] = "stark bew\u00F6lkt";
    WeatherCondition["BEDECKT"] = "bedeckt";
    WeatherCondition["REGENSCHAUER"] = "Regenschauer";
    WeatherCondition["REGEN"] = "Regen";
    WeatherCondition["GEWITTER"] = "Gewitter";
    WeatherCondition["SCHNEESCHAUER"] = "Schneeschauer";
    WeatherCondition["SCHNEEFALL"] = "Schneefall";
    WeatherCondition["SCHNEEREGEN"] = "Schneeregen";
    WeatherCondition["NEBEL"] = "Nebel";
    WeatherCondition["IN_WOLKEN"] = "in Wolken";
    WeatherCondition["SPRUEHREGEN"] = "Spr\u00FChregen";
})(WeatherCondition || (WeatherCondition = {}));
export var WeatherIcons;
(function (WeatherIcons) {
    WeatherIcons["NBedeckt"] = "MsNBedeckt";
    WeatherIcons["NBewoelkt"] = "MsNBewoelkt";
    WeatherIcons["NGewitter"] = "MsNGewitter";
    WeatherIcons["NKlar"] = "MsNKlar";
    WeatherIcons["NNebel"] = "MsNNebel";
    WeatherIcons["NRegen"] = "MsNRegen";
    WeatherIcons["NSchauer"] = "MsNSchauer";
    WeatherIcons["NSchnee"] = "MsNSchnee";
    WeatherIcons["NSonnig"] = "MsNSonnig";
    WeatherIcons["NSpruehregen"] = "MsNSpruehregen";
    WeatherIcons["NWolkig"] = "MsNWolkig";
    WeatherIcons["TBedeckt"] = "MsTBedeckt";
    WeatherIcons["TBewoelkt"] = "MsTBewoelkt";
    WeatherIcons["TGewitter"] = "MsTGewitter";
    WeatherIcons["TKlar"] = "MsTKlar";
    WeatherIcons["TNebel"] = "MsTNebel";
    WeatherIcons["TRegen"] = "MsTRegen";
    WeatherIcons["TSchauer"] = "MsTSchauer";
    WeatherIcons["TSchnee"] = "MsTSchnee";
    WeatherIcons["TSchneeschauer"] = "MsTSchneeschauer";
    WeatherIcons["TSonnig"] = "MsTSonnig";
    WeatherIcons["TSpruehregen"] = "MsTSpruehregen";
    WeatherIcons["TWolkig"] = "MsTWolkig";
    WeatherIcons["MsTemp"] = "MsTemp";
    WeatherIcons["MsTiefsttemperatur"] = "MsTiefsttemperatur";
    WeatherIcons["MsUnwetter"] = "MsUnwetter";
    WeatherIcons["MsUv"] = "MsUv";
    WeatherIcons["MsAbnehmend"] = "MsAbnehmend";
    WeatherIcons["MsDichteGering"] = "MsDichteGering";
    WeatherIcons["MsDichteHoch"] = "MsDichteHoch";
    WeatherIcons["MsDichteMittel"] = "MsDichteMittel";
    WeatherIcons["MsGewitter"] = "MsGewitter";
    WeatherIcons["MsHoechsttemperatur"] = "MsHoechsttemperatur";
    WeatherIcons["MsInWolken"] = "MsInWolken";
    WeatherIcons["MsMondAbnehmend"] = "MsMondAbnehmend";
    WeatherIcons["MsMondVoll"] = "MsMondVoll";
    WeatherIcons["MsMondZunehmend"] = "MsMondZunehmend";
    WeatherIcons["MsNeumond"] = "MsNeumond";
    WeatherIcons["MsOzon"] = "MsOzon";
    WeatherIcons["MsRegenwahrscheinlichkeit"] = "MsRegenwahrscheinlichkeit";
    WeatherIcons["MsSchneeregen"] = "MsSchneeregen";
    WeatherIcons["MsSonnenstunden"] = "MsSonnenstunden";
    WeatherIcons["MsStarkBewoelkt"] = "MsStarkBewoelkt";
    WeatherIcons["MsSunrise"] = "MsSunrise";
    WeatherIcons["MsSunset"] = "MsSunset";
})(WeatherIcons || (WeatherIcons = {}));
//# sourceMappingURL=weatherService.js.map